import * as React from "react";
import "../styles/Modal.css";
import ReactModal from "react-modal";
import {presetInfo } from "../api/dataTypes";

interface State {
    presets:presetInfo;
}

export interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  editPresets: (editData:presetInfo) => void;
  presets:presetInfo;
  winderName:string;
}

export class EditPresetsModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
        presets:{
            id:0,
            winderId:0,
            preset1:0,
            preset2:0,
            preset3:0,
            preset4:0,
            preset5:0,
            preset6:0,
            preset7:0,
            preset8:0,
          }
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!nextProps.isModalOpen || (nextProps.presets.id !==0)) {
        this.setState({
            presets: JSON.parse(JSON.stringify(nextProps.presets)),
        })
    }
}

  render() {
    return (
        <div className="Modal">
            <ReactModal
            ariaHideApp={false}
            isOpen={this.props.isModalOpen}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            onRequestClose={this.props.closeModal}
            className={{
              base: "modal-content edit-modal",
              afterOpen: "modal-content_after-open",
              beforeClose: "modal-content_before-close"
            }}
            overlayClassName={{
              base: "modal-overlay",
              afterOpen: "modal-overlay_after-open",
              beforeClose: "modal-overlay_before-close"
            }}
            >
                <div className="container edit-modal">
                    <label className="label-large col-form-label">
                            Edit Presets ({this.props.winderName})
                    </label>
                    <div className="row form-group" />
                    <div className="row form-group d-flex align-items-center">
                        <div className="col-3">
                            <label className="modal-text">Preset 1</label>
                            <input
                                type="number"
                                step={10}
                                className="form-control"
                                value={this.state.presets.preset1}
                                onChange={this.onInputChange}
                                name="preset1"
                                tabIndex={1}
                                autoFocus={true}
                            />
                        </div>
                        <div className="col-3">
                            <label className="modal-text">Preset 2</label>
                            <input
                                type="number"
                                step={10}
                                className="form-control"
                                value={this.state.presets.preset2}
                                onChange={this.onInputChange}
                                name="preset2"
                                tabIndex={2}
                            />
                        </div>
                        <div className="col-3">
                            <label className="modal-text">Preset 3</label>
                            <input
                                type="number"
                                step={10}
                                className="form-control"
                                value={this.state.presets.preset3}
                                onChange={this.onInputChange}
                                name="preset3"
                                tabIndex={3}
                            />
                        </div>
                        <div className="col-3">
                            <label className="modal-text">Preset 4</label>
                            <input
                                type="number"
                                step={10}
                                className="form-control"
                                value={this.state.presets.preset4}
                                onChange={this.onInputChange}
                                name="preset4"
                                tabIndex={4}
                            />
                        </div>

                    </div>
                    <hr/>
                    <div className="row form-group d-flex align-items-center">
                        <div className="col-3">
                            <label className="modal-text">Preset 5</label>
                            <input
                                type="number"
                                step={10}
                                className="form-control"
                                value={this.state.presets.preset5}
                                onChange={this.onInputChange}
                                name="preset5"
                                tabIndex={5}
                            />
                        </div>
                        <div className="col-3">
                            <label className="modal-text">Preset 6</label>
                            <input
                                type="number"
                                step={10}
                                className="form-control"
                                value={this.state.presets.preset6}
                                onChange={this.onInputChange}
                                name="preset6"
                                tabIndex={6}
                            />
                        </div>
                        <div className="col-3">
                            <label className="modal-text">Preset 7</label>
                            <input
                                type="number"
                                step={10}
                                className="form-control"
                                value={this.state.presets.preset7}
                                onChange={this.onInputChange}
                                name="preset7"
                                tabIndex={7}
                            />
                        </div>
                        <div className="col-3">
                            <label className="modal-text">Preset 8</label>
                            <input
                                type="number"
                                step={10}
                                className="form-control"
                                value={this.state.presets.preset8}
                                onChange={this.onInputChange}
                                name="preset8"
                                tabIndex={8}
                            />
                        </div>

                    </div>
                    <div className="row form-group">
                        <div className="col">
                            <button
                                className="btn btn-block button-standard confirm-button"
                                disabled={false}
                                tabIndex={9}
                                onClick={this.confirmButtonPressed}
                            >
                                Confirm
                        </button>
                        </div>
                        <div className="col">
                            <button
                                className="btn btn-block button-standard cancel-button"
                                tabIndex={10}
                                onClick={this.cancelButtonPressed}
                            >
                                Close/Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </ReactModal>
        </div>
    )
  }

private onInputChange = (
    e:
        | React.SyntheticEvent<HTMLInputElement>
        | React.SyntheticEvent<HTMLSelectElement>
    ) => {
        let newPresets = this.state.presets;
        newPresets[e.currentTarget.name] = e.currentTarget.value;
        this.setState({
            presets:newPresets
        });
}

private confirmButtonPressed = () => {
    this.props.editPresets(this.state.presets);
    this.props.closeModal();
}

private cancelButtonPressed = () => {
    this.setState({
        presets:{
            id:0,
            winderId:0,
            preset1:0,
            preset2:0,
            preset3:0,
            preset4:0,
            preset5:0,
            preset6:0,
            preset7:0,
            preset8:0,
          }
    });
    this.props.closeModal();
}


}